export default __webpack_public_path__ + "static/media/female_kidney.629c529e.png";